// extracted by mini-css-extract-plugin
export default {"dialog":"BCorporateTreeButton-module_dialog_be992fef","close":"BCorporateTreeButton-module_close_e4dbc836"};